import React from "react";
import LivestreamChild from "./LiveStreaming";
import Draggable from "react-draggable";
import { useNavigate } from "react-router-dom";

/**
 * shows a button which when clicked shows some videos in PIP, clicking
 * again turns it off.
 */
const PIPComponent = () => {
    const history = useNavigate();

    const eventControl = (event, info) => {
        if (event.target.id == "pop-big") {
            history.push("/page/livestream");
        }
    };

    return (
        <Draggable
            onStart={eventControl}
            onMouseDown={eventControl}
            onDrag={eventControl}
            onStop={eventControl}
        >
            <div className="pip-view">
                <LivestreamChild isPIP={true} />
            </div>
        </Draggable>
    );
};

export default PIPComponent;
